var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('qr-holder',{tag:"component",attrs:{"prefix":_vm.prefix,"value":_vm.code,"message":'Scan this in Tallyflow Mobile to associate a handheld with this endpoint.'}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-181f19bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"objectAssign":"Object.assign","transforms":{"stripWith":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/EndpointQRCode.vue
// module id = null
// module chunks = 